import React from 'react'
import { Row, Col, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

const Subject = ({ subject, color }) => {
  
    let classColor = "card bg-gradient-" + color;
    let classButton = "primary  bg-gradient-" + color + " border border-0 rounded-pill"

  return (
    <div className="card99">       
      <div className={classColor}>
          <div className="card-body">
            <div className="row ">
                <div className="col centerCard111 ">
                <span className="h2 font-weight-bold text-white centerCard1"  style={{textTransform: 'capitalize'}}>{subject.tittle}</span>
                {/* <p className="card-text  navText2 textCard42">{subject.description} </p> */}
                </div>
                <div className="col-auto cardIcon">
                <div className="icon icon-shape bg-white text-dark rounded-circle shadow">
                    <i className="ni ni-hat-3 "></i>
                </div>
                </div>
            </div>
          <p className=" text-sm text-center courseLinks">
             

            <LinkContainer to={`/teachereditsubject/${subject._id}`} className='btn btn-default '>
                    <Button variant={classButton}>  Edit Subject  </Button>
            </LinkContainer>               

            <LinkContainer to={`/teacherwatchcourse/${subject.course}`} className='btn btn-default '>
                    <Button variant={classButton}>  Add Lessons </Button>
            </LinkContainer>  

            <LinkContainer to={`/teacherpreviousanswers/${subject._id}`} className='btn btn-default subjectCourse '>
                    <Button variant={classButton}>  Previous Questions </Button>
            </LinkContainer>
          

            </p>
        </div>
      </div>
    </div>
  )
};

export default Subject